var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass: "btn btn-book-now btn-highlight",
      class: { "btn-disabled": _vm.$store.state.bookingDisabled },
      attrs: { href: _vm.localBookingLink, title: "Click to book room now" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleClick.apply(null, arguments)
        },
      },
    },
    [_vm._v("PROCEED TO BOOK")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }